import React from 'react';
import { Link } from 'gatsby';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

const Holder = styled.nav`
  ul { 
    padding-left: 0;
    list-style: none;
    li {
      @media(${props => props.theme.breakpoints.md}) {
        display: inline-block;
        margin-right: 1.5rem;
      }
      a[aria-current="page"] {
        text-decoration: underline;
      }
    }
  }
  p {
    margin-top: 2rem;
    @media(${props => props.theme.breakpoints.md}) {
      display: none;
    }
  }
`;

function Navigation( { onLinkClick } ) {

  const clickHandler = () => {
    if ( onLinkClick ) {
      onLinkClick();
    }
  };

  return (
    <Holder>
      <ul className="sans">
        <li><Link to="/functions-and-events/" onClick={() => clickHandler()}>Functions & Events</Link></li>
        <li><Link to="/the-restaurant/" onClick={() => clickHandler()}>The Restaurant</Link></li>
        <li><Link to="/about-the-marion/" onClick={() => clickHandler()}>About The Marion</Link></li>
        <li><Link to="/contact/" onClick={() => clickHandler()}>Contact</Link></li>
      </ul>
      <p><Link to="/enquire" className="button" onClick={() => clickHandler()}>Enquire now</Link></p>
    </Holder>
  )
}

Navigation.propTypes = {
  onLinkClick: PropTypes.func
};

export default Navigation;
